import React from "react";
import logo from "../images/ks-logo.png";
import QRCode from "../images/qr-code-img.png";
import NewImg from "../images/ks-new-logo.png";
const KS2Header = (props) => {
  return (
    <React.Fragment>
      <div className="header row">
        <div className="col-sm-12 col-md-4 col-lg-3 ">
          <div className="logo">
            <img src={logo} className="icd-logo" alt="logo" />
          </div>
        </div>
        <div className="col-sm-12 col-md-8 col-lg-6 qr-code">
          <div className="qr-code-img">
            <img src={QRCode} className="qr-img" alt="logo" />
          </div>
          <div className="qr-code-text">KS2 0920</div>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-3 text-right ">
          <div className="id-date">
            KS2
            <span>September 2020</span>
          </div>

          <div className="new-logo-img">
            <img src={NewImg} className="new-logo" alt="logo" />
          </div>
        </div>
      </div>
      <div className="">
        <div className="col-sm-12 col-md-12 col-lg-12">
          <h2 className="page-title pb-0 mb-0">KiwiSaver deduction form</h2>
          <p className="page-title-sub-ks2">Do not send this form to Inland Revenue. This form should be kept by your employer with your employment records.</p>
        </div>
        <div className="col-sm-12 col-md-12 col-lg-12 kiwisaver-act">KiwiSaver Act 2006</div>
      </div>
    </React.Fragment>
  );
};
export default KS2Header;
